import React from "react";
import backImage from "../assets/images/back_image.jpg";

export default function TextileBackground({ children, className = "" }) {
  return (
    <div
      className={`relative min-h-screen bg-cream-100 ${className}`}
      style={{
        backgroundImage: `url(${backImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
      }}
    >
      <div className="relative z-10">{children}</div>
    </div>
  );
}
